import script from "./appeal-status.vue?vue&type=script&setup=true&lang=js"
export * from "./appeal-status.vue?vue&type=script&setup=true&lang=js"

import "./appeal-status.vue?vue&type=style&index=0&id=57557991&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57557991"]])

export default __exports__